import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { AxiosProvider } from './components/Provider/AxiosProvider';
import MsalWaiter from './msalWaiter';
import './i18n';

// Components
import AppRouter from './Router/AppRouter';

// MSAL imports
import msalConfig from './components/AzureAD/authConfig';

// Styles
import './styles/styles.css';

let msalInstance;

async function asyncCallForInitialize() {
  msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();

  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Watch for logins from other tabs and windows
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const { account } = event.payload;
      msalInstance.setActiveAccount(account);
    }
  });
}

asyncCallForInitialize();

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <MsalWaiter>
        <AxiosProvider>
          <AppRouter />
        </AxiosProvider>
      </MsalWaiter>
    </MsalProvider>
  </React.StrictMode>
);
